import React from "react";
import linkedin from "../assets/images/linkedIn.svg";
import gmail from "../assets/images/gmail.png";
import github from "../assets/images/github.jpg";
import resume from "../assets/images/resume.png";

function Contact() {
    return (
        <div className="body">
            <main className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="page-header">
                            <h1 className="headingStyle">Contact</h1>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <hr />
                            <a href="mailto: kevinhellman94@gmail.com">
                                <img src={gmail} className="gmail" alt="gmail icon" />
                            </a>
                            <a href="https://www.linkedin.com/in/kevin-hellman-2645781a9/">
                                <img src={linkedin} className="linkedIn" alt="github icon" />
                            </a>
                            <a href="https://github.com/kmh8827">
                                <img src={github} className="github" alt="linked-in icon" />
                            </a>
                            <a href="https://docs.google.com/document/d/1RoQUU5pnDFDK-VF0PWH58E2WMkUFgAkhoi47QcupWi4/edit?usp=sharing">
                                <img src={resume} className="resume" alt="resume icon" />
                            </a>
                        </div>
                    </div>
                    <p className="content">If you would like to reach me you can do so at any of the above links 
                    or contact me at my phone number of (919) 302-3556</p>
                    <br />
                    <br />

                </div>

            </main>
        </div>
    )
};

export default Contact;